/* eslint-disable no-unused-vars */
import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useImperativeHandle,
} from 'react';
import {
  // TextField, Select, MenuItem,
  Checkbox,
} from '@material-ui/core';
import {
  // Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  // TablePagination,
  TableRow,
  TextField,
  FormControl,
  FormHelperText,
  Box,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { useTheme } from '@material-ui/core';
import { DataTableNativeMLStyled } from './DataTableNativeMLStyled';
import PaginationML from '@/components/PaginationML';
import InitPaginationML from '@/components/InitPaginationML';
import Body from '@/components/Body';
import { Controller, useForm } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import sort01 from '@/assets/img/nkc-sort-01.png';
import sort02 from '@/assets/img/nkc-sort-02.png';
import sort03 from '@/assets/img/nkc-sort-03.png';
import RadioML from '../RadioML';
// import { changeTableData } from '@/utils/comUtil';

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(
  props,
  ref,
) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      thousandsGroupStyle="thousand"
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator={true}
      allowNegative={false}
      isNumericString
      prefix=""
    />
  );
});

const DataTableML = ({
  className,
  loading = false,
  columns = [],
  data = [],
  total,
  page = {
    pageNum: 1,
    pageSize: 10,
  },
  rowEdit = false, //  是否可编辑
  changePage = () => {},
  changeChecked = () => {},
  sortField, //sortField 排序字段
  setSortField = () => {},
  sortType, //sortType排序模式 multiline为多行排序
  tableRef, // 点击时查找到子组件节点
  validateSubmit, // 校验
  columnSort, // 是否是前端排序
  setColumnSort = () => {},
  isColumnSort,
  setIsColumnSort = () => {},
  isOtherColumnSort,
  setIsOtherColumnSort = () => {},
  isFrontSort,
  // paging = true,
  selection = false,
  sorting = false,
  title,
  orderObj,
  singleSelect = false,
  buttonTitle,
  pageButton = true,
  scroll = true,
  width = '100%',
  devicesMinWidth = '1680',
  columnKey,
  itemCheckedAble, // 有的行有复选框有的行没有复选框
  chooseIds = [],
  chooseData = [],
  np = false,
  initP = false,
  headerTip = false,
  currentCount, //选择条数
  hasNext,
  FootContent = null,
  showPagingData = {},
  pages,
  showPageColor = false,
  titleStyle,
  tableIsShow = false,
  showPageSize = true,
  ...rest
}) => {
  const theme = useTheme();
  const { handleSubmit, control, setValue, errors, reset } = useForm();
  const formRef = useRef();
  // const [pageState, setPageState] = useState({
  //   pageSize: 10,
  //   pageNum: 1,
  // });

  useImperativeHandle(tableRef, () => ({
    onSubmit: onSubmit,
    type: 'dataTableSubmit',
  }));

  const onSubmit = () => {
    if (tableDataSelf.length === 1) {
      let emptyObj = true;
      // 判断在只有一行时，所有属性除默认必加的外其余都不存在时，不校验
      for (const key in tableDataSelf[0]) {
        if (columnKey.indexOf(key) < 0 && tableDataSelf[0][key]) {
          emptyObj = false;
        }
      }
      if (emptyObj) {
        validateSubmit && validateSubmit([], 'success');
      } else {
        formRef.current.click();
      }
    } else {
      formRef.current.click();
    }
  };

  const [selected, setSelected] = React.useState([]);
  const [selectedItemCheckedAble, setSelectedItemCheckedAble] = React.useState(
    [],
  ); // 有的行有复选框有的行没有复选框的情况下，点击全选时用到的
  const [selectedItemArr, setSelectedItemArr] = React.useState([]);
  const [tableDataSelf, setTableDataSelf] = useState([{}]);

  const changeTableData = (key, value, index, tableData) => {
    tableData[index][key] = value;
    return tableData;
  };

  // 初始化设置form值
  // useEffect(() => {
  //   if (rowEdit && data && columns && data.length > 0 && columns.length > 0) {
  //     if (data.length === 1) {
  //       // && isEmptyObject(data[0])
  //       reset();
  //     } else {
  //       columns.forEach((column, cIndex) => {
  //         data.forEach((item, dIndex) => {
  //           if (column.type) {
  //             setValue(
  //               column.id + dIndex + cIndex,
  //               item[column.id] === undefined ? '' : item[column.id],
  //             );
  //           }
  //         });
  //       });
  //     }
  //   }
  // }, [data, columns, rowEdit, setValue, reset]);
  useEffect(() => {
    setSelected(chooseIds);
    const newSelectedItemArr = selectedItemArr.filter((item) =>
      chooseIds.includes(item[columnKey]),
    );
    setSelectedItemArr(newSelectedItemArr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chooseIds?.length]);

  // useEffect(() => {
  //   setPageState({
  //     total: total,
  //     pageSize: page.pageSize,
  //     pageNum: page.pageNum,
  //   });
  // }, [page.pageNum, page.pageSize, total]);

  useMemo(() => {
    setTableDataSelf(data);
  }, []);

  //自定义校验 添加输入框数值的正负校验
  const validate = {
    isValue: (e) => {
      if (e <= 0) {
        return false;
      }
    },
  };

  // 修改某一项值后返回整个data数据和修改值，
  // value是输入值，需要进行保存,或者
  const handleItemChange = (key, value, index, event, rowId) => {
    const status = tableDataSelf.find((item) => item.id === rowId);
    status &&
      setTableDataSelf(changeTableData(key, value, index, tableDataSelf));
    event?.onChange &&
      event.onChange(changeTableData(key, value, index, data), value);
  };
  // 选择多行
  const onSelectAllClick = (event) => {
    if (event.target.checked) {
      // 判断 有的行有复选框有的行没有复选框的情况下全选
      if (itemCheckedAble) {
        const selectedItemCheckedAbleUnuse = data.filter(
          (n) => n[itemCheckedAble],
        );
        const newSelecteds = selectedItemCheckedAbleUnuse.map(
          (n) => n[columnKey ? columnKey : 'id'],
        );
        columns[0]?.onChange &&
          columns[0].onChange(newSelecteds, {}, selectedItemCheckedAbleUnuse);
        setSelected(newSelecteds);
        setSelectedItemArr(selectedItemCheckedAbleUnuse);
        setSelectedItemCheckedAble(selectedItemCheckedAbleUnuse);
        return;
      }
      const newSelecteds = data.map((n) => n[columnKey ? columnKey : 'id']);
      const dataSort = data.map((i) => ({
        ...i,
        SORTTIME: new Date().getTime(),
      }));
      columns[0]?.onChange &&
        columns[0].onChange([...selected, ...newSelecteds], {}, [
          ...selectedItemArr,
          ...dataSort,
        ]);
      setSelected([...selected, ...newSelecteds]);
      setSelectedItemArr([...selectedItemArr, ...dataSort]);
      return;
    }
    const rowKeys = data.map((item) => item[columnKey ? columnKey : 'id']);
    //过滤当前页数据，保留其他页已经选中的数据
    const selectedIds = [...selected]?.filter(
      (item) => !rowKeys.includes(item),
    );
    const selectedFilterItemArr = [...selectedItemArr]?.filter(
      (item) => !rowKeys.includes(item[columnKey ? columnKey : 'id']),
    );
    columns[0]?.onChange &&
      columns[0].onChange(selectedIds, {}, selectedFilterItemArr);
    // const keys = data.map(item=>item[columnKey ? columnKey : 'id']);
    // const others = selected.filter(item=>!keys.includes(item));
    // console.log('others', others);
    setSelected(selectedIds);
    setSelectedItemArr(selectedFilterItemArr);
  };
  //只可以单选的时候
  const handleSingleSelect = (event, item) => {
    const selectedIndex = selected.indexOf(item[columnKey ? columnKey : 'id']);
    let newSelected = [];
    let newSelectedItemArr = [];
    if (selectedIndex === -1) {
      newSelected = [item[columnKey ? columnKey : 'id']];
      newSelectedItemArr = [item];
    } else if (selectedIndex === 0) {
      newSelected = [];
      newSelectedItemArr = [];
    }
    columns[0]?.onChange &&
      columns[0].onChange(newSelected, item, newSelectedItemArr);
    setSelected(newSelected);
    setSelectedItemArr(newSelectedItemArr);
  };
  // 选择单行
  const handleClick = (event, newItem) => {
    const item = { ...newItem, SORTTIME: new Date().getTime() };
    const selectedIndex = selected.indexOf(item[columnKey ? columnKey : 'id']);
    let newSelected = [];
    let newSelectedItemArr = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(
        selected,
        item[columnKey ? columnKey : 'id'],
      );
      newSelectedItemArr = newSelectedItemArr.concat(selectedItemArr, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      newSelectedItemArr = newSelectedItemArr.concat(selectedItemArr.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      newSelectedItemArr = newSelectedItemArr.concat(
        selectedItemArr.slice(0, -1),
      );
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
      newSelectedItemArr = newSelectedItemArr.concat(
        selectedItemArr.slice(0, selectedIndex),
        selectedItemArr.slice(selectedIndex + 1),
      );
    }
    columns[0]?.onChange &&
      columns[0].onChange(newSelected, item, newSelectedItemArr);
    setSelected(newSelected);
    setSelectedItemArr(newSelectedItemArr);
  };

  // 判断行是否被选中
  const isSelected = (e) => selected?.indexOf(e) !== -1;
  const isChecked = useMemo(() => {
    const rowKeys = data.map((item) => item[columnKey ? columnKey : 'id']);
    let checkedIt = true;
    for (let v of rowKeys) {
      if (!selected.includes(v)) {
        checkedIt = false;
        break;
      }
    }
    return checkedIt;
  }, [data, selected, columnKey]);

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const sortBy = isOtherColumnSort ? 'desc' : 'asc';
  return (
    <DataTableNativeMLStyled
      theme={theme}
      // className="testshenjie"
      // style={{ overflow: 'hidden', width: width }}
      tableLayout={'fixed'}
      devicesMinWidth={devicesMinWidth}
      np={np}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {title ? (
          <div className="title" style={titleStyle?.titleWrapStyle}>
            <div style={titleStyle?.titleInfoStyle}>{title}</div>
            <div className="button-wrapper">
              {buttonTitle?.length > 0 &&
                buttonTitle.map((i) => (
                  <Button
                    key={i.text}
                    sx={i?.style}
                    variant={i.variant || 'contained'}
                    onClick={i.onClick}
                  >
                    {i.text}
                  </Button>
                ))}
            </div>
          </div>
        ) : (
          <div></div>
        )}
        {headerTip && headerTip}
      </div>
      <Body bizData={data} loading={loading} tableIsShow={tableIsShow}>
        {/* <div className="srcollSet"></div> */}

        <div className="table-wrap">
          <div className="table-content">
            <Table>
              <TableHead className="table-header">
                <TableRow>
                  {columns[0] && columns[0].type === 'checkbox' ? (
                    <TableCell
                      padding="checkbox"
                      align="center"
                      className={columns[0].cellClass}
                      style={{
                        ...columns[0].thCellStyle,
                        width: `${columns[0].width ?? 50}px`,
                        minWidth: `${columns[0].width ?? 50}px`,
                      }}
                    >
                      {singleSelect ? (
                        <div></div>
                      ) : (
                        <Checkbox
                          indeterminate={false}
                          checked={isChecked}
                          onChange={onSelectAllClick}
                          inputProps={{ 'aria-label': 'select all desserts' }}
                        />
                      )}
                    </TableCell>
                  ) : (
                    ''
                  )}
                  {columns.map((column, index) => {
                    const Id = column.id;
                    if (column.type === 'checkbox') {
                      return '';
                    }
                    const { sort } = column;
                    let Sort = {};
                    if (sort) {
                      Sort = sort;
                    }
                    const { orderBy, sortChange = () => {} } = Sort;
                    //判断方向
                    const createSortHandler = (id, direction) => {
                      // let Order;
                      // _order[id] === 'asc' ? (Order = 'desc') : (Order = 'asc');
                      sortChange(id, direction);
                      // onRequestSort(event, property);
                    };
                    return (
                      <TableCell
                        key={
                          column[columnKey ? columnKey : 'id']
                            ? column[columnKey ? columnKey : 'id'] +
                              '-key-index' +
                              index
                            : 'action-column-key-index' + index
                        }
                        align={column.align}
                        // align="center"
                        className={column.cellClass}
                        style={{
                          ...column.thCellStyle,
                          width: column.width ? `${column.width}px` : '120px',
                          minWidth: column.width
                            ? `${column.width}px`
                            : '120px',
                        }}
                      >
                        {column.sort ? (
                          <TableSortLabel
                            active={orderBy === Id}
                            direction={orderObj && orderObj[Id]}
                            onClick={() => {
                              let direction;
                              orderObj[Id] === 'asc'
                                ? (direction = 'desc')
                                : (direction = 'asc');
                              createSortHandler(Id, direction);
                            }}
                            // 点击排序
                          >
                            {column.title}
                            {/* {orderBy === column.id ? (
                          <span className="visuallyHidden">
                            {order !== 'desc' ? '降序' : '升序'}
                          </span>
                        ) : null} */}
                          </TableSortLabel>
                        ) : (
                          column.title
                        )}
                        {/* 前端排序 */}
                        {column.frontSort && (
                          <img
                            className="sort-img"
                            // 默认为sort01 倒序：sort02 正序：sort03
                            // 点击时每一列排序 其他列恢复默认排序
                            src={
                              columnSort !== column.id
                                ? sort01
                                : isOtherColumnSort
                                ? sort02
                                : sort03
                            }
                            onClick={() => {
                              setIsOtherColumnSort(
                                columnSort === column.id
                                  ? !isOtherColumnSort
                                  : isOtherColumnSort,
                              );
                              setIsColumnSort(column.id !== columnSort);
                              setColumnSort(column?.id);
                            }}
                            alt=""
                          />
                        )}
                        {/* sortType=multiline为多行排序 */}
                        {sortType === 'multiline' && column?.isSort && (
                          <img
                            className="sort-img"
                            src={column?.fieldSort ? sort02 : sort03}
                            onClick={() => {
                              if (column?.setSort) {
                                column.setSort(!column?.fieldSort);
                                setSortField && setSortField(column.key);
                              } else {
                                column.callback(column.key, !column?.fieldSort);
                              }
                            }}
                            alt=""
                          />
                        )}
                        {/* sortType=singleLine为单行排序 */}
                        {sortType === 'singleLine' && column?.isSort && (
                          <img
                            className="sort-img"
                            src={
                              !column?.fieldSort && sortField === column.key
                                ? sort03
                                : sort02
                            }
                            onClick={() => {
                              column?.setSort &&
                                column.setSort(!column?.fieldSort);
                              setSortField && setSortField(column.key);
                            }}
                            alt=""
                          />
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
            </Table>
            <form
              onSubmit={handleSubmit(
                (formData) => {
                  validateSubmit &&
                    validateSubmit(tableDataSelf, 'success', formData);
                },
                (formData) => {
                  validateSubmit &&
                    validateSubmit(tableDataSelf, 'error', formData);
                },
              )}
            >
              <Button
                type="submit"
                // onClick={}
                ref={formRef}
                style={{ display: 'none' }}
              ></Button>
              <TableContainer className="table-container">
                <Table
                  aria-label="sticky table"
                  style={{ tableLayout: 'fixed' }}
                >
                  <TableBody>
                    {/* 前端排序取值 */}
                    {isFrontSort &&
                      stableSort(data, getComparator(sortBy, columnSort)) &&
                      stableSort(data, getComparator(sortBy, columnSort))
                        .slice(
                          (page.pageNum - 1) * page.pageSize,
                          page.pageNum * page.pageSize,
                        )
                        .map((row, rowIndex, arry) => {
                          const isItemSelected = isSelected(
                            row[columnKey ? columnKey : 'id'],
                          );
                          const labelId = `enhanced-table-checkbox-${rowIndex}`;
                          // isOtherColumnSort 真则倒序，假则正序
                          return (
                            <TableRow
                              hover
                              tabIndex={-1}
                              role="checkbox"
                              key={'row' + rowIndex}
                              className={
                                rowIndex % 2 === 1 ? 'row-backgroud' : ''
                              }
                            >
                              {columns.map((column, colIndex) => {
                                let name =
                                  String(column.id) + rowIndex + colIndex;
                                let value;
                                if (column['id']) {
                                  value = row[column.id];
                                }
                                if (column.render) {
                                  value = column.render(
                                    row,
                                    rowIndex,
                                    colIndex,
                                  );
                                }
                                return (
                                  <TableCell
                                    key={
                                      String(
                                        column[columnKey ? columnKey : 'id'],
                                      ) +
                                      rowIndex +
                                      colIndex
                                    }
                                    align={column.align}
                                    className={
                                      isItemSelected
                                        ? 'table-row-selected ' +
                                          column.cellClass
                                        : column.cellClass
                                    }
                                    style={{
                                      ...column.tdCellStyle,
                                      width: column.width
                                        ? `${column.width}px`
                                        : '120px',
                                      minWidth: column.width
                                        ? `${column.width}px`
                                        : '120px',
                                    }}
                                    onClick={() =>
                                      column.event &&
                                      column.event.onClick &&
                                      column.event.onClick(value, row)
                                    }
                                  >
                                    {value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                    {!isFrontSort &&
                      data &&
                      data.map((row, rowIndex, arry) => {
                        const isItemSelected = isSelected(
                          row[columnKey ? columnKey : 'id'],
                        );
                        const labelId = `enhanced-table-checkbox-${rowIndex}`;
                        // isOtherColumnSort 真则倒序，假则正序
                        return (
                          <TableRow
                            hover
                            tabIndex={-1}
                            role="checkbox"
                            key={'row' + rowIndex}
                            className={
                              rowIndex % 2 === 1 ? 'row-backgroud' : ''
                            }
                          >
                            {columns[0] && columns[0].type === 'checkbox' ? (
                              <TableCell
                                padding="checkbox"
                                align="center"
                                className={
                                  isItemSelected
                                    ? 'table-row-selected ' +
                                      columns[0].cellClass
                                    : columns[0].cellClass
                                }
                                style={{
                                  ...columns[0].tdCellStyle,
                                  width: `${columns[0].width ?? 50}px`,
                                  minWidth: `${columns[0].width ?? 50}px`,
                                }}
                              >
                                {itemCheckedAble ? (
                                  row[itemCheckedAble] ? (
                                    <Checkbox
                                      checked={isItemSelected}
                                      inputProps={{
                                        'aria-labelledby': labelId,
                                      }}
                                      onChange={(event) => {
                                        singleSelect
                                          ? handleSingleSelect(event, row)
                                          : handleClick(event, row);
                                      }}
                                    />
                                  ) : (
                                    ''
                                  )
                                ) : singleSelect ? (
                                  <RadioML
                                    checked={isItemSelected}
                                    inputProps={{
                                      'aria-labelledby': labelId,
                                    }}
                                    onChange={(event) =>
                                      singleSelect
                                        ? handleSingleSelect(event, row)
                                        : handleClick(event, row)
                                    }
                                  />
                                ) : (
                                  <Checkbox
                                    checked={isItemSelected}
                                    inputProps={{
                                      'aria-labelledby': labelId,
                                    }}
                                    onChange={(event) =>
                                      singleSelect
                                        ? handleSingleSelect(event, row)
                                        : handleClick(event, row)
                                    }
                                  />
                                )}
                              </TableCell>
                            ) : (
                              ''
                            )}
                            {columns.map((column, colIndex) => {
                              let name =
                                String(column.id) + rowIndex + colIndex;
                              if (column.type === 'checkbox') {
                                return '';
                              }
                              if (column.type === 'input') {
                                const val = chooseData.find(
                                  (item) => item.id === row.id,
                                )?.[column.id];
                                const rowId = chooseData.find(
                                  (item) => item.id === row.id,
                                )?.id;
                                return (
                                  <TableCell
                                    key={
                                      column.id + rowIndex + colIndex + row.id
                                    }
                                    align={column.align}
                                    // style={column.cellStyle}
                                    style={{
                                      ...column.cellStyle,
                                      width: `${column.width}px` ?? '50px',
                                      minWidth: `${column.width}px` ?? '50px',
                                    }}
                                    // className={column.cellClass}
                                    className={
                                      isItemSelected
                                        ? 'table-row-selected ' +
                                          columns[0].cellClass
                                        : columns[0].cellClass
                                    }
                                    onClick={() =>
                                      column.event &&
                                      column.event.onClick &&
                                      column.event.onClick(value, row)
                                    }
                                  >
                                    <FormControl>
                                      <Controller
                                        render={(pr) => (
                                          <TextField
                                            variant="standard"
                                            // type={'number'}
                                            value={pr.value ?? val}
                                            onChange={(e) => {
                                              handleItemChange(
                                                column.id,
                                                e.target.value,
                                                rowIndex,
                                                column.event,
                                                rowId,
                                              );
                                              return pr.onChange(
                                                e.target.value,
                                              );
                                            }}
                                            InputProps={{
                                              inputComponent:
                                                NumberFormatCustom,
                                            }}
                                            error={Boolean(errors[name])}
                                          />
                                        )}
                                        defaultValue={val}
                                        name={name}
                                        control={control}
                                        rules={{
                                          // required: Boolean(column.required),
                                          required: Boolean(
                                            chooseIds.find((i) => i === row.id),
                                          ),
                                          validate: {
                                            isValue: validate.isValue,
                                          },
                                        }}
                                      />
                                      <FormHelperText
                                        error={Boolean(errors[name])}
                                      >
                                        {/* {Boolean(errors[name]) &&
                                          `请输入${column.title}`} */}
                                        {Boolean(errors[name]) && '张数需为正'}
                                      </FormHelperText>
                                    </FormControl>
                                  </TableCell>
                                );
                              }
                              let value;
                              if (column['id']) {
                                value = row[column.id];
                              }
                              if (column.render) {
                                value = column.render(row, rowIndex, colIndex);
                                // console.log('value2', value);
                              }

                              return (
                                <TableCell
                                  key={
                                    String(
                                      column[columnKey ? columnKey : 'id'],
                                    ) +
                                    rowIndex +
                                    colIndex
                                  }
                                  align={column.align}
                                  className={
                                    isItemSelected
                                      ? 'table-row-selected ' + column.cellClass
                                      : column.cellClass
                                  }
                                  style={{
                                    ...column.tdCellStyle,
                                    width: column.width
                                      ? `${column.width}px`
                                      : '120px',
                                    minWidth: column.width
                                      ? `${column.width}px`
                                      : '120px',
                                  }}
                                  onClick={() =>
                                    column.event &&
                                    column.event.onClick &&
                                    column.event.onClick(value, row)
                                  }
                                >
                                  {value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </form>
          </div>
          {data?.length > 0 && pageButton && (
            <Box>
              {initP ? (
                <Box
                  display="flex"
                  gap="172px"
                  justifyContent="flex-end"
                  marginTop={
                    showPagingData?.marginTop ? showPagingData.marginTop : 0
                  }
                >
                  <InitPaginationML
                    hasNext={hasNext}
                    page={page}
                    total={total}
                    changePages={changePage}
                    showPagingDataStatus={showPagingData?.status}
                    showPageColor={showPageColor}
                    pages={pages}
                  />
                  {FootContent}
                </Box>
              ) : (
                <Box
                  display="flex"
                  flexDirection="column"
                  gap="30px"
                  justifyContent="flex-end"
                  mt={3}
                >
                  <PaginationML
                    page={page}
                    total={total}
                    showPageSize={showPageSize}
                    changePages={changePage}
                  />
                  {FootContent}
                </Box>
              )}
            </Box>
          )}
        </div>
      </Body>
      {(!data || data?.length === 0) && pageButton && initP && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '24px',
          }}
        >
          {FootContent}
        </Box>
      )}
    </DataTableNativeMLStyled>
  );
};

export default DataTableML;
